var apiGateway = {
	baseUrl: "https://propelld.com/api/",
};

module.exports = {
  apiGateway,
};